import React from 'react';
import { Loader } from '../../../src/components/ui/loader';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import SEO from '../../../src/components/SEO';
import Article from '../../../src/components/ptt/Article';
import NavBar from '../../../src/components/NavBar';
import {
  selectFirebaseAuthed,
  selectFirebaseAuthIsLoaded,
} from '../../../src/selectors';

const PTTArticle = (props: { authIsLoaded: boolean; authed: boolean }) => {
  const router = useRouter();
  const { pid } = router.query;

  const { authIsLoaded, authed } = props;

  return (
    <>
      <SEO title="PTT 文章" description="PTT 文章內容" />
      <NavBar>
        {!authIsLoaded ? (
          <Loader />
        ) : (
          <Article authed={authed} id={pid as string} />
        )}
      </NavBar>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  authIsLoaded: selectFirebaseAuthIsLoaded(state),
  authed: selectFirebaseAuthed(state),
});

export default connect(mapStateToProps)(PTTArticle as any);
